import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { Money } from '@dreryk/money-common-api';
import { AppointmentAdvancePaymentOnlinePayment } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { AdvancePaymentActionVariant } from './AdvancePaymentActionTrigger';
import { AdvancePaymentIssueUnderpaymentActionLink } from './AdvancePaymentIssueUnderpaymentActionLink';
import { AdvancePaymentIssuePaymentActionLink } from './AdvancePaymentIssuePaymentActionLink';

type AdvancePaymentIssueUnderpaymentLinksProps = {
   appointmentId: AppointmentId;
   remainingAmount: Money;
   pendingOnlinePayments?: AppointmentAdvancePaymentOnlinePayment[];
   variant?: AdvancePaymentActionVariant;
};

export const AdvancePaymentIssueUnderpaymentLinks = (
   props: AdvancePaymentIssueUnderpaymentLinksProps
): JSX.Element | null => {
   const variant = props.variant ?? 'link';
   const hasPendingPayments = props.pendingOnlinePayments && props.pendingOnlinePayments.length > 0;
   const hasRemainingAmount = props.remainingAmount.asNumber() > 0;

   const links: JSX.Element[] = [];

   if (hasPendingPayments) {
      props.pendingOnlinePayments!.forEach((pendingOnlinePayment, index) => {
         const label = index === 0 ? translationKeys.shareLinkToPayment : translationKeys.shareLinkToUnderpayment;
         links.push(
            <AdvancePaymentIssueUnderpaymentActionLink
               key={pendingOnlinePayment.onlinePaymentId}
               variant={variant}
               label={label}
               appointmentId={props.appointmentId}
               requiredAmount={pendingOnlinePayment.requiredAmount}
               onlinePaymentId={pendingOnlinePayment.onlinePaymentId}
            />
         );
      });
   }

   if (hasRemainingAmount) {
      const label = hasPendingPayments ? translationKeys.shareLinkToUnderpayment : translationKeys.shareLinkToPayment;
      links.push(
         <AdvancePaymentIssuePaymentActionLink
            key={'issuePayment'}
            variant={variant}
            label={label}
            appointmentId={props.appointmentId}
         />
      );
   }

   if (links.length === 0) {
      return null;
   }

   if (variant === 'dropdownItem') {
      return <>{links}</>;
   }

   return (
      <StyledFlex direction={'column'} gap={'4px'}>
         {links}
      </StyledFlex>
   );
};
